import { render, staticRenderFns } from "./BenefitsCard.vue?vue&type=template&id=2d6cf0f2&scoped=true&"
import script from "./BenefitsCard.vue?vue&type=script&lang=js&"
export * from "./BenefitsCard.vue?vue&type=script&lang=js&"
import style0 from "./BenefitsCard.vue?vue&type=style&index=0&id=2d6cf0f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6cf0f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VIcon,VRow})
